module.exports = __webpack_public_path__ + "img/music_024.81b76cfc.png";